import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { renderAddinLogout } from './addin-logout/addin-logout';

if (environment.production) {
  enableProdMode();
}

function bootstrapAngular() {
  import('./app/app.module').then(m => {
    platformBrowserDynamic().bootstrapModule(m.AppModule)
      .catch(err => console.error(err));
  });
}

if (window.location.pathname.indexOf('addin-logout') !== -1) {
  // Render standalone logout page — Angular never bootstraps on this route
  renderAddinLogout();
} else {
  // Normal Angular bootstrap — dynamic import prevents module tree loading on logout page
  bootstrapAngular();
}
